import defaultPageData from "constants/defaultPageData";

const getPageTitle = (title, defaultTitle = defaultPageData.defaultTitle) => {
    const pageTitle = [title, defaultTitle].filter((value) => value);

    return pageTitle.join(defaultPageData.separator);
};

export default getPageTitle;
